export default __webpack_public_path__ + "static/hp-pharmaco-tsat-chart-SM-54af46543ba603ca14c1280b1a069916.png";